import {Select} from 'antd'
import { withSelectWithTwoLabels } from './withSelectWithTwoLabels'

export const SelectWithTwoLabels = withSelectWithTwoLabels(Select)
